export enum ValidityTypes {
    NOTDIRTY,
    INVALID,
    DATAINVALID,
    NOERROR
}
